import React from 'react'
import '../../style/component.css'
import { Avatar, Layout, Space } from 'antd';
import Logo from '../../assets/png/logo.png'
import ProfileMenu from './ProfileMenu';
import { useAuth } from '../../context/authContext';
import ParentProfileMenu from './ParentProfileMenu';
import StaffProfileMenu from './StaffProfileMenu';
const { Header } = Layout;

function Headers({ setIsLoading }) {
    const { userType } = useAuth()

    return (
        <Header className='headers'>
            <div className='logo'>
                <img src={Logo} />
            </div>
            <Space>
                <div className="show_profile">
                    {userType === "Admin" ? <ProfileMenu setIsLoading={setIsLoading} /> : userType === "Staffs" ? <StaffProfileMenu /> : <ParentProfileMenu />}
                </div>
            </Space>
        </Header>
    )
}

export default Headers